/**
 * PDP FireKing Hero
 * Self-contained — does not touch safe-builder.js. Handles size-card
 * selection, gallery slide swap (against snippets/product__newImages.liquid
 * markup), the disabled-until-selected Add to Cart button, and the
 * per-variant "Fire" chip swap.
 */
(function () {
  function initHero(hero) {
    var form = hero.querySelector('[data-fk-hero-form]');
    if (!form) return;

    var cta = hero.querySelector('[data-fk-cta]');
    var variantInput = hero.querySelector('[data-fk-selected-variant]');
    var fireChip = hero.querySelector('[data-fk-fire-chip]');
    var fireChipDefault = fireChip ? fireChip.textContent : '';
    var weightChip = hero.querySelector('[data-fk-weight-chip]');
    var weightChipDefault = weightChip ? weightChip.textContent : '';
    var priceEl = hero.querySelector('[data-fk-price]');
    var summaryTitleEl = hero.querySelector('[data-fk-summary-title]');
    var summaryPriceEl = hero.querySelector('[data-fk-summary-price]');
    var cards = hero.querySelectorAll('[data-fk-size-card]');
    var productId = hero.getAttribute('data-product-id');
    var gallery = document.querySelector('.sb-gallery[data-product-id="' + productId + '"]');

    function activateGallerySlide(mediaId) {
      if (!gallery || !mediaId) return;
      var slide = gallery.querySelector('.sb-gallery__slide[data-media-id="' + mediaId + '"]');
      if (!slide) return;

      var activeSlides = gallery.querySelectorAll('.sb-gallery__slide.is-active');
      for (var i = 0; i < activeSlides.length; i++) {
        activeSlides[i].classList.remove('is-active');
      }
      slide.classList.add('is-active');

      var index = slide.getAttribute('data-index');
      var activeThumbs = gallery.querySelectorAll('.sb-gallery__thumb.is-active');
      for (var j = 0; j < activeThumbs.length; j++) {
        activeThumbs[j].classList.remove('is-active');
      }
      var thumb = gallery.querySelector('.sb-gallery__thumb[data-index="' + index + '"]');
      if (thumb) thumb.classList.add('is-active');
    }

    function selectCard(card) {
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.remove('is-selected');
      }
      card.classList.add('is-selected');

      var input = card.querySelector('[data-fk-size-input]');
      if (!input) return;

      variantInput.value = input.value;
      cta.disabled = false;
      var addToCartText = cta.getAttribute('data-add-to-cart-text');
      if (addToCartText) cta.textContent = addToCartText;

      var mediaId = card.getAttribute('data-media-id');
      activateGallerySlide(mediaId);

      var fireDisplay = card.getAttribute('data-fire-display');
      if (fireChip) {
        fireChip.textContent = fireDisplay || fireChipDefault;
      }

      var weightDisplay = card.getAttribute('data-weight-display');
      if (weightChip) {
        weightChip.textContent = weightDisplay || weightChipDefault;
      }

      var price = card.getAttribute('data-price');
      var title = card.getAttribute('data-title');
      if (priceEl && price) priceEl.textContent = price;
      if (summaryTitleEl && title) summaryTitleEl.textContent = title;
      if (summaryPriceEl && price) summaryPriceEl.textContent = price;
      var summary = hero.querySelector('[data-fk-summary]');
      if (summary) summary.classList.add('has-selection');
    }

    cards.forEach(function (card) {
      var input = card.querySelector('[data-fk-size-input]');
      if (!input) return;

      card.addEventListener('click', function () {
        if (input.disabled) return;
        input.checked = true;
        selectCard(card);
      });

      input.addEventListener('change', function () {
        if (input.checked) selectCard(card);
      });
    });

    initGalleryControls(gallery);
    initThumbNavArrows(gallery);
  }

  // snippets/product__newImages.liquid renders thumbnail buttons and a main-image
  // prev/next arrow pair, but its click behavior normally comes from
  // assets/product-gallery.js — which is only loaded by safe-builder-section.liquid,
  // never by this hero. Without this, the arrows and thumbnails rendered but did
  // nothing when clicked. Kept self-contained here rather than also loading
  // product-gallery.js, to avoid two scripts both trying to control the same
  // .sb-gallery markup.
  function initGalleryControls(gallery) {
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.sb-gallery__slide');
    var thumbs = gallery.querySelectorAll('.sb-gallery__thumb');
    var prevBtn = gallery.querySelector('.sb-gallery__arrow--prev');
    var nextBtn = gallery.querySelector('.sb-gallery__arrow--next');
    if (!slides.length) return;

    function activateIndex(index) {
      var target = String(index);
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-index') === target);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-index') === target);
      });
    }

    function currentIndex() {
      var active = gallery.querySelector('.sb-gallery__slide.is-active');
      var parsed = active ? parseInt(active.getAttribute('data-index'), 10) : 0;
      return isNaN(parsed) ? 0 : parsed;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateIndex(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        activateIndex((currentIndex() - 1 + slides.length) % slides.length);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activateIndex((currentIndex() + 1) % slides.length);
      });
    }
  }

  // Mobile-only nav arrows for the thumbnail rail (a vertical column on
  // desktop, a horizontally-scrollable row on mobile — see the CSS). Purely a
  // scroll aid alongside swipe; doesn't change which photo is active. Built
  // via JS rather than in snippets/product__newImages.liquid itself, since
  // that snippet is shared and this wrapper is FireKing-hero-specific.
  function initThumbNavArrows(gallery) {
    if (!gallery) return;
    var thumbs = gallery.querySelector('.sb-gallery__thumbs');
    if (!thumbs || thumbs.parentNode.classList.contains('fk-hero__thumbs-wrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'fk-hero__thumbs-wrap';
    thumbs.parentNode.insertBefore(wrap, thumbs);
    wrap.appendChild(thumbs);

    function makeArrow(direction, label) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fk-hero__thumbs-arrow fk-hero__thumbs-arrow--' + (direction < 0 ? 'prev' : 'next');
      btn.setAttribute('aria-label', label);
      var points = direction < 0 ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
      btn.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="' +
        points +
        '"></polyline></svg>';
      btn.addEventListener('click', function () {
        var firstThumb = thumbs.querySelector('.sb-gallery__thumb');
        var gap = 10;
        var step = firstThumb ? firstThumb.getBoundingClientRect().width + gap : 74;
        thumbs.scrollBy({ left: direction * step, behavior: 'smooth' });
      });
      return btn;
    }

    wrap.insertBefore(makeArrow(-1, 'Scroll to previous thumbnails'), thumbs);
    wrap.appendChild(makeArrow(1, 'Scroll to next thumbnails'));
  }

  document.querySelectorAll('[data-fk-hero]').forEach(initHero);
})();
